import React, { useState } from 'react';
import Odd from './common/Odd';
import { HANDICAP_TYPES_TO_SORT_BY_DESC } from './data/constants';
import { getBetDescription } from './data/utils/getBetDescription';
import Bet from './starcasino/components/Bet';
import { getGroupBetDescription } from './betway/utils/getGroupBetDescription';

function getFirstLine(bets) {
    let bet = bets[0];
    for (let i = 0; i < bets.length; i++) {
        if (bets[i]?.mainLine > 0 && bets[i].mainLine === bets[i].handicap) {
            bet = bets[i];
            break;
        }
    }
    return bet;
}

function sortBetsByHandicap(a, b) {
    if (HANDICAP_TYPES_TO_SORT_BY_DESC.includes(a.tipoHandicap)) {
        return a.handicapDesc - b.handicapDesc;
    } else {
        return a.handicap - b.handicap;
    }
}

export default function HandicapSelector(props) {
    const bets = props.bets;
    const [handicap, setHandicap] = useState(getFirstLine(bets).handicap);
    const [toggled, setToggled] = useState(false);

    function changeHandicap(handicap) {
        setHandicap(handicap);
        setToggled(false);
    }

    let selected = bets.find(b => b.handicap === handicap);
    if (selected == null) {
        // if we are here, then the previously set handicap is not available anymore so we need to select a new default bet from the new ones
        selected = getFirstLine(bets);
    }
    const desc = getBetDescription(selected);

    const content = (
        <>
            {selected.odds.length > 2 ?
                <div className="mb-1 relative grid grid-flow-row gap-1">
                    <div className={`px-1 grid grid-cols-5 items-center justify-between border border-cs7 rounded-lg handicap-wrapper ${desc}`}  onClick={() => setToggled(!toggled)}>
                        <span className="col-start-1 col-end-5 font-medium text-xs truncate">{desc}</span>
                        <i className="col-start-5 col-end-6 justify-self-end xs-font-icon bi-chevron-expand" />
                    </div>
                    {toggled &&
                        <div className="max-h-[200px] overflow-y-auto mt-1 bg-cs1 border border-cs7 rounded-lg">
                            <div key={selected.uniqueId} className={`p-2 flex items-center justify-between font-bold text-xs`}>
                                <span>{selected.handicapTableDesc}</span>
                                {selected.odds.length <= 3 && selected.odds.map(o =>
                                    <span key={o.uniqueId}>{o.desc}</span>
                                )}
                            </div>
                            {bets.map(b => b).sort(sortBetsByHandicap).map(b => {
                                const classes = b.handicap === selected.handicap ? 'bg-cs4 text-cs1 first:rounded-t-md last:rounded-b-md' : 'text-cs6';
                                return (
                                    <div key={b.uniqueId} className={`p-2 flex items-center justify-between font-medium text-xs ${classes}`} onClick={() => changeHandicap(b.handicap)}>
                                        <span>{b.handicapDesc}</span>
                                        {b.odds.length <= 3 && b.odds.map(o =>
                                            <span key={o.uniqueId}>{o.value}</span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    }
                    {selected.odds.map(o =>
                        <Odd key={o.uniqueId} data={o} noHandicap={true} />
                    )}
                </div>
                :
                <div className="mb-1 relative">
                    <div className="mb-1 px-1 grid grid-cols-5 items-center justify-between border border-cs7 rounded-lg" onClick={() => setToggled(!toggled)}>
                        <span className="col-start-1 col-end-5 font-medium text-xs truncate">{desc}</span>
                        <i className="col-start-5 col-end-6 justify-self-end xs-font-icon bi-chevron-expand" />
                    </div>
                    {toggled && 
                        <div className="max-h-[200px] overflow-y-auto mb-1 bg-cs1 border border-cs7 rounded-lg">
                            <div key={selected.uniqueId} className={`p-2 flex items-center justify-between font-bold text-xs`}>
                                <span>{selected.handicapTableDesc}</span>
                                {selected.odds.map(o =>
                                    <span key={o.uniqueId}>{o.desc}</span>
                                )}
                            </div>
                            {bets.map(b => b).sort(sortBetsByHandicap).map(b => {
                                const classes = b.handicap === selected.handicap ? 'bg-cs4 text-cs1 first:rounded-t-md last:rounded-b-md' : 'text-cs6';
                                return (
                                    <div key={b.uniqueId} className={`p-2 flex items-center justify-between font-medium text-xs ${classes}`} onClick={() => changeHandicap(b.handicap)}>
                                        <span>{b.handicapDesc}</span>
                                        {b.odds.map(o =>
                                            <span key={o.uniqueId}>{o.value}</span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    }
                    <div className={`grid xs-cols-layout-${selected.odds.length} gap-1`}>
                        {selected.odds.map(o =>
                            <Odd key={o.uniqueId} data={o} noHandicap={true} />
                        )}
                    </div>
                </div>
            }
        </>
    );

    switch (props.headingType) {
        case 'full':
            return (
                <Bet desc={getGroupBetDescription(bets[0])} data={bets[0]}>
                    {content}
                </Bet>
            );
        default:
            return content;
    }
}
